module.exports = __webpack_public_path__ + "img/TC.803e18a2.svg";